/* eslint-disable max-len */
import React from 'react'
import { useSelector } from 'react-redux'
import AnimatedList from '../../../../../../components/Animation/AnimatedList'
import { convertEpochToDateFormat } from '../../../../../../CommonMethods/DateConversion'

const TableBody = ({
    tableData,
    indexNum,
}) => {
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    
    const valuesToUpdate={
        'inactive':'Inactive',
        'active':'Active',
        'monitor':'Monitor',
        'view':'View',
        'true':'True',
        'false':'False',
        'email':'Email',
        'call':'Call'
    }    
    const date=convertEpochToDateFormat(tableData?.timestamp,dateformat)
    const formattedVitalType = tableData?.vital_type?.replace(/_/g, ' ')?.replace(/\b\w/g, (char) => char.toUpperCase());

    return(
        <>
            <AnimatedList
                id={tableData.user_id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                child={
                    <> 
                        <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">
                            {tableData?.user_name}
                        </td>
                        <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">
                            {date}
                        </td>
                        <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624]">
                            {formattedVitalType==="Spo2"?"SPO2":formattedVitalType}
                        </td>
                        <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] break-all" style={{lineBreak:'anywhere'}}>{tableData?.new_start==='' ? '-' : valuesToUpdate[tableData?.new_start]?valuesToUpdate[tableData?.new_start]:tableData?.new_start}</td>
                        <td className='px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] break-all' style={{lineBreak:'anywhere'}}>{tableData?.new_frequency==='' ? '-' : valuesToUpdate[tableData?.new_frequency]?valuesToUpdate[tableData?.new_frequency]:tableData?.new_frequency}</td>
                        <td className='px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] break-all' style={{lineBreak:'anywhere'}}>{tableData?.new_delay==='' ? '-' : valuesToUpdate[tableData?.new_delay]?valuesToUpdate[tableData?.new_delay]:tableData?.new_delay}</td>
                        <td className='px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] break-words'>{tableData?.new_threshold==='' ? '-' : valuesToUpdate[tableData?.new_threshold]?valuesToUpdate[tableData?.new_threshold]:tableData?.new_threshold}</td>
                        <td className='px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] break-all' style={{lineBreak:'anywhere'}}>{tableData?.old_start==='' ? '-' : valuesToUpdate[tableData?.old_start]?valuesToUpdate[tableData?.old_start]:tableData?.old_start}</td>
                        <td className='px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] break-all' style={{lineBreak:'anywhere'}}>{tableData?.old_frequency==='' ? '-' : valuesToUpdate[tableData?.old_frequency]?valuesToUpdate[tableData?.old_frequency]:tableData?.old_frequency}</td>
                        <td className='px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] break-all' style={{lineBreak:'anywhere'}}>{tableData?.old_delay==='' ? '-' : valuesToUpdate[tableData?.old_delay]?valuesToUpdate[tableData?.old_delay]:tableData?.old_delay}</td>
                        <td className='px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] break-words'>{tableData?.old_threshold==='' ? '-' : valuesToUpdate[tableData?.old_threshold]?valuesToUpdate[tableData?.old_threshold]:tableData?.old_threshold}</td>
                     
                    </>
                    
                }/>
           
        </>
    )
}

export default TableBody